/*
 * vendor/documents.js — esbuild IIFE entry
 * Migrated from app/assets/javascripts/vendor/documents.js
 * Provides VendorDocuments for vendor registration document upload forms.
 */
import 'blueimp-file-upload';

window.VendorDocuments = {
    errorClass: 'vendor-registration-document-error',

    initializeForms() {
        $('.document-input').fileupload({
            url: $(this).data('url'),
            dataType: 'json',
            type: 'PATCH',
            add: (e, data) => {
                const prevText = $(e.target).parents('tr').find('.status').text();
                if (prevText !== I18n.t('vendor.requirements.uploading')) { this._prevText = prevText; }
                $(e.target).parents('tr').find('.status').text(I18n.t('vendor.requirements.uploading'));
                data.submit();
            },
            done: (e, data) => {
                const { result } = data.response();
                if (result.success) {
                    this._removeError();
                    const $link = $('<a>').attr({ href: result.document.link, target: '_blank' }).text(result.document.name);
                    $(e.target).parents('tr').find('.status').empty().append($link);
                    $(e.target).parents('tr').find('.uploaded_date').text(result.document.uploaded);
                    $(e.target).parents('tr').find('.actions').find('.upload-document').text(I18n.t('vendor.requirements.replace'));
                    if (result.registration_completed) {
                        $('.submit_registration').removeAttr('disabled').addClass('pt-green');
                    }
                } else {
                    $(e.target).parents('tr').find('.status').text(this._prevText || '');
                    this._renderError();
                }
            }
        });

        $('.upload-document').on('click', function () {
            $(this).parent().find('input').click();
        });
    },

    _renderError() {
        $(`<div class="alert alert-box nomargin ${this.errorClass}" data-alert="">
      ${I18n.t('errors.1803')}
      <a class="close"><i class="pti pt-cancel" href="#"></i></a>
    </div>`).appendTo($('body'));
    },

    _removeError() {
        $(`.${this.errorClass}`).remove();
    }
};
